export default __webpack_public_path__ + "static/media/c2.7df13cfe.png";